module.exports = __webpack_public_path__ + "img/share_poster_2.53aa786e.svg";